import Option from '../select/src/option';

Option.install = function(Vue) {
  Vue.component(Option.name, Option);
};

export default Option;



// WEBPACK FOOTER //
// ./src/components/option/index.js